import { combineReducers } from 'redux';
import Auth from './Auth';
import Data from './Data';
import Archive from './Archive';

export default combineReducers({
	auth: Auth,
	data: Data,
	archive: Archive,
});
